import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT  } from "constants/variables";
import Box from '@mui/material/Box'; 
import CircularProgress from '@mui/material/CircularProgress'; 
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';  
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice'; 
import TableSortingStoreDrivers from "pages/stores/storeEdit/SortingTablesStoreDriver";
import PropTypes from 'prop-types'; 

const initialFiltersDriver= {
  "idFrom":"",
  "idTo":"",
  "documentIdFrom":"",
  "documentIdTo":"",
  "tradenameFrom":"",
  "tradenameTo":""
};
 
const initialStateDriver = [{
  "driver_id":"",
  "driver_documentid":"",
  "driver_tradename":""
}];

const StoreSearchDrivers = ({ showModalSearchDrivers, setShowModalSearchDrivers,setNewVehicle}) => {
  const {t,i18n} = useTranslation(['listDataShipping']);
  const state = useSelector((state) => state);
  const {token} = state.loginUser;
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesize);
  const [dataDriver, setDataDriver] = useState(initialStateDriver);
  const [isLoadingErrorDriver, setIsLoadingErrorDriver] = useState(false);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [inputTextDriver, setInputTextDriver] = useState("");
  const [applyFiltersDriver, setApplyFiltersDriver]= useState(initialFiltersDriver);
  const [filtersDriver, setFiltersDriver]= useState(initialFiltersDriver);
  const [openEditFilterDriver,setOpenEditFilterDriver]= useState(false);
  const [errorsFiltersDriver, setErrorsFiltersDriver] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegDriver,setNumTotRegDriver]= useState(0);
  const [activeOffsetDriver, setActiveOffsetDriver]= useState(false);
  const [currencyOffsetDriver, setCurrencyOffsetDriver] = useState(0);
  const [rangeOffsetDriver, setRangeOffsetDriver] = useState([{}]); 
  const dispatch = useDispatch(); 
   
  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && setShowModalSearchDrivers) {
        setDataDriver(initialStateDriver);
        setIsLoadingErrorDriver(false);
        dispatch(setLoading(false));
        setInputTextDriver("");
        setApplyFiltersDriver(initialFiltersDriver);
        setFiltersDriver(initialFiltersDriver);
        setOpenEditFilterDriver(false);
        setErrorsFiltersDriver({});
        setNumTotRegFilter(0);
        setNumTotRegDriver(0);
        setActiveOffsetDriver(false);
        setCurrencyOffsetDriver(0);
        setRangeOffsetDriver([{}]);
        setShowModalSearchDrivers(false);
      }
    },
    [ setDataDriver,
      setIsLoadingErrorDriver, 
      setInputTextDriver,
      setApplyFiltersDriver,
      setFiltersDriver,
      setOpenEditFilterDriver,
      setErrorsFiltersDriver,
      setNumTotRegFilter,
      setNumTotRegDriver,
      setActiveOffsetDriver,
      setCurrencyOffsetDriver,
      setRangeOffsetDriver,
      dispatch,
      setShowModalSearchDrivers
    ]
  );

  const handleCloseDataEditDriver = () => {
    setDataDriver(initialStateDriver);
    setIsLoadingErrorDriver(false);
    dispatch(setLoading(false));
    setInputTextDriver("");
    setApplyFiltersDriver(initialFiltersDriver);
    setFiltersDriver(initialFiltersDriver);
    setOpenEditFilterDriver(false);
    setErrorsFiltersDriver({});
    setNumTotRegFilter(0);
    setNumTotRegDriver(0);
    setActiveOffsetDriver(false);
    setCurrencyOffsetDriver(0);
    setRangeOffsetDriver([{}]);
    setShowModalSearchDrivers(false)
	};

  const toggleDrawerSearchFormDriver  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditDriver();
    }
  };

  let inputHandlerDriver = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextDriver(lowerCase);
  };

  const openEditFiltersDriver = () => {
    setFiltersDriver(applyFiltersDriver);
    setOpenEditFilterDriver(!openEditFilterDriver);
  };

  const toggleDrawerFilterEditDriver = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditDriver();
    }
  };

  const handleCancelFiltersDriver = () => {
    setErrorsFiltersDriver({});
    setFiltersDriver(initialFiltersDriver);
    setOpenEditFilterDriver(!openEditFilterDriver);
  };

  const handleChangeFilterEditDriver = (e) => {
    const { name, value } = e.target;
    setFiltersDriver(filtersDriver => ({
      ...filtersDriver,
      [name]: value
    }));
  };

  const handleBlurFilterEditDriver = (e) => {
    setErrorsFiltersDriver(validateFormFilterDriver());
    handleChangeFilterEditDriver(e);
  };

  const handleSubmitFilterEditDriver = () => {
    setErrorsFiltersDriver(validateFormFilterDriver());
    if (Object.keys(errorsFiltersDriver).length === 0) {
      setApplyFiltersDriver(filtersDriver);
      setFiltersDriver(initialFiltersDriver);
      setErrorsFiltersDriver({});
      setOpenEditFilterDriver(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeleteFiltersDriver = () => {
    setErrorsFiltersDriver({});
    setFiltersDriver(initialFiltersDriver);
    setApplyFiltersDriver(initialFiltersDriver);
    setOpenEditFilterDriver(!openEditFilterDriver);
  };

  const validateFormFilterDriver = () => {

    let errorsFiltersDriver = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (filtersDriver.idFrom!=="" & !regexNumber.test(filtersDriver.idFrom)) {
      errorsFiltersDriver.idFrom = 'Text_TextNoNumber';
    }
    if (filtersDriver.idTo!=="" & !regexNumber.test(filtersDriver.idTo)) {
      errorsFiltersDriver.idTo = 'Text_TextNoNumber';
    }
    if (filtersDriver.idFrom!=="" & !errorsFiltersDriver.idFrom!==undefined){
      if (filtersDriver.idTo!=="" & !errorsFiltersDriver.idTo!==undefined){
        if (parseInt(filtersDriver.idTo)<parseInt(filtersDriver.idFrom)){
          errorsFiltersDriver.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersDriver.documentIdFrom)) {
      errorsFiltersDriver.documentIdFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersDriver.documentIdTo)) {
      errorsFiltersDriver.documentIdTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersDriver.tradenameFrom)) {
      errorsFiltersDriver.tradenameFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersDriver.tradenameTo)) {
      errorsFiltersDriver.tradenameTo = 'Text_TextNoValid';
    } 
     
    if (filtersDriver.documentIdTo!=="" & filtersDriver.documentIdTo<filtersDriver.documentIdFrom){
      errorsFiltersDriver.documentIdTo = 'Text_TextGreater_documentid';
    }
    if (filtersDriver.tradenameTo!=="" & filtersDriver.tradenameTo<filtersDriver.tradenameFrom){
      errorsFiltersDriver.tradenameTo = 'Text_TextGreater_driver';
    } 
    return errorsFiltersDriver;
  }  

  const filteredDataDriver = dataDriver.filter((el) => {
    if (inputTextDriver === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.driver_id || '')+
        String(el.driver_documentid || '')+
        String(el.driver_tradename || '');
      let result = dataTranslate.toLowerCase().includes(inputTextDriver.toLowerCase());
      return result; 
    }
  })
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegDriver = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `store/getinformationtablesdriver`, token);
        if (getData.err) {
          setDataDriver(initialStateDriver);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegDriver(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
 
    const fetchnumTotRegFilter = async () => {
      try {
        const getData = await helpHttp().post(ENDPOINT,`store/getcountfilterdriver`,token,applyFiltersDriver);
        if (getData.err || getData.message === "Load failed") {
          setDataDriver(initialStateDriver);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchDataDriver = async () => {
      dispatch(setLoading(false));
      try {
        const getData = await helpHttp().get3(ENDPOINT,`store/getdrivers`,token,currencyOffsetDriver,LIMITPAGESIZE,applyFiltersDriver);
        if (getData.err || getData.message === "Load failed") {
          setDataDriver(initialStateDriver);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataDriver(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    if (showModalSearchDrivers){
      fetchnumTotRegDriver();
      fetchnumTotRegFilter();
      fetchDataDriver();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,LIMITPAGESIZE,applyFiltersDriver,currencyOffsetDriver,showModalSearchDrivers]);
  
  return(
    <>
      {showModalSearchDrivers &&  
        <SwipeableDrawer
          anchor='right'
          open={true}
          onClose={toggleDrawerSearchFormDriver(false)}
          onOpen={toggleDrawerSearchFormDriver(true)}>
          <Container >
            <Box sx={{ bgcolor: '#ffffff', width: '1000px'}}>
              <br/>
              <div className="formdi-pending-header2"> 
                <h1 className="formdi-pending-title">
                  {isLoadingErrorDriver?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_DRIVERS_Search')}
                </h1>
                <div>
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={handleCloseDataEditDriver}>{t('Button_Back')}</button><> </>
                </div> 
              </div>  
              <br/> 
              <div className="formdi-pending-search"> 
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  value={inputTextDriver}
                  inputProps={{ style: {fontSize: '18px'} }}
                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                  placeholder={t('Text_DRIVERS_Search_BY')} 
                  onChange={inputHandlerDriver}
                  fullWidth
                  label={t('Text_DRIVERS_Search_BY')}>
                </TextField> 
              </div>
              <br/>
              <div id="myNewDIV" className="formdi-pending-filters">
                <h1 className="formdi-pending-filter-title">{t('Text_Filter')}</h1> 
                <div className="formdi-pending-filters-row">
                  <button type="button" className={`formdi-pending-chip ${applyFiltersDriver.documentIdFrom !== "" || applyFiltersDriver.documentIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersDriver} >
                    <span className={`formdi-pending-dot ${ applyFiltersDriver.documentIdFrom !== "" || applyFiltersDriver.documentIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_documentid")}
                  </button>
                  <button type="button" className={`formdi-pending-chip ${applyFiltersDriver.tradenameFrom !== "" || applyFiltersDriver.tradenameTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersDriver} >
                    <span className={`formdi-pending-dot ${ applyFiltersDriver.tradenameFrom !== "" || applyFiltersDriver.tradenameTo !== ""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_DRIVER")}
                  </button> 
                </div>
              </div>  
              <br/> 
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content"> 
                    <TableSortingStoreDrivers
                      dataDriver={filteredDataDriver}
                      numTotRegFilter={ numTotRegFilter}
                      titleTable={t('Text_DRIVER_Table')}
                      numTotRegDriver={numTotRegDriver}
                      activeOffsetDriver={activeOffsetDriver}
                      rangeOffsetDriver={rangeOffsetDriver}
                      currencyOffsetDriver={currencyOffsetDriver}
                      setCurrencyOffsetDriver={setCurrencyOffsetDriver}
                      setNewVehicle={setNewVehicle}
                      handleCloseDataEditDriver={handleCloseDataEditDriver}
                    >
                    </TableSortingStoreDrivers>
                </div>             
              </div>
              {openEditFilterDriver &&
                <div>
                <SwipeableDrawer
                  anchor='right'
                  open={true}
                  onClose={toggleDrawerFilterEditDriver(false)}
                  onOpen={toggleDrawerFilterEditDriver(true)}>
                  <Container >
                    <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                      <br/>
                        <div id="myDIV">
                          <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                        </div>
                        <hr className="sidebar-divider d-none d-md-block"/>
                        <form className="newfilterformstore" onSubmit={handleCancelFiltersDriver}>  
                          <div className="form-floating mb-3 px-4 primary">
                            <div className="form-group">
                              <TextField
                                id="documentIdFrom" 
                                name="documentIdFrom"
                                value={filtersDriver.documentIdFrom}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={errorsFiltersDriver.documentIdFrom!=null?t(errorsFiltersDriver.documentIdFrom):t('Text_Filter_documentId_From')}
                                placeholder={t('PlaceHolder_Filter_documentid_From')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditDriver}
                                onChange={handleChangeFilterEditDriver}/>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <TextField
                                id="documentIdTo" 
                                name="documentIdTo"
                                value={filtersDriver.documentIdTo}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={errorsFiltersDriver.documentIdTo!=null?t(errorsFiltersDriver.documentIdTo):t('Text_Filter_documentId_To')}
                                placeholder={t('PlaceHolder_Filter_documentid_to')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditDriver}
                                onChange={handleChangeFilterEditDriver}/>
                            </div>
                            <div className="form-group">
                              <TextField
                                id="tradenameFrom" 
                                name="tradenameFrom"
                                value={filtersDriver.tradenameFrom}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={errorsFiltersDriver.tradenameFrom!=null?t(errorsFiltersDriver.tradenameFrom):t('Text_Filter_driver_From')}
                                placeholder={t('PlaceHolder_Filter_driver_From')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditDriver}
                                onChange={handleChangeFilterEditDriver}/>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <TextField
                                id="tradenameTo" 
                                name="tradenameTo"
                                value={filtersDriver.tradenameTo}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={errorsFiltersDriver.tradenameTo!=null?t(errorsFiltersDriver.tradenameTo):t('Text_Filter_driver_To')}
                                placeholder={t('PlaceHolder_Filter_driver_to')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditDriver}
                                onChange={handleChangeFilterEditDriver}/>
                            </div> 
                          </div>
                            <hr className="sidebar-divider d-none d-md-block"/>
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditDriver}>
                              {t('Button_Apply')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersDriver}>
                              {t('Button_Cancel_Filters')}
                            </button>
                          </div>
                      </form>
                    </Box>
                  </Container>
                </SwipeableDrawer>
              </div>
            } 
            </Box>
          </Container>
        </SwipeableDrawer> 
      } 
    </>
  )
}

StoreSearchDrivers.propTypes = {
  showModalSearchDrivers: PropTypes.bool.isRequired,
  setShowModalSearchDrivers: PropTypes.func.isRequired, 
  setNewVehicle: PropTypes.func.isRequired
};

export default StoreSearchDrivers;
